import { useCallback, useState } from 'react'

interface IUseFinalizeDocument {
  finalizeWithoutSaving: () => void
  finalizeWithSaving: () => void
}

export const useFinalizeDocument = ({
  finalizeWithSaving,
  finalizeWithoutSaving,
}: IUseFinalizeDocument) => {
  const [showModal, setShowModal] = useState(false)

  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  const closeModal = useCallback(() => {
    setShowModal(false)
  }, [])

  const onFinalizeWithoutSavingClick = useCallback(() => {
    finalizeWithoutSaving()
    closeModal()
  }, [closeModal, finalizeWithoutSaving])

  const onFinalizeWithSavingClick = useCallback(() => {
    finalizeWithSaving()
    closeModal()
  }, [closeModal, finalizeWithSaving])

  return {
    showModal,
    onFinalizeWithoutSavingClick,
    onFinalizeWithSavingClick,
    openModal,
    closeModal,
  }
}
